const jakartaDateTimeFormatter = new Intl.DateTimeFormat('id-ID', {
  day: '2-digit',
  hour: '2-digit',
  hour12: false,
  minute: '2-digit',
  month: 'short',
  timeZone: 'Asia/Jakarta',
});

export function formatTransactionDatetime(
  isoString: string | null | undefined
): string {
  if (!isoString) return '-';
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '-';

  const parts = jakartaDateTimeFormatter.formatToParts(date);
  const getPart = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? '';

  return `${getPart('day')} ${getPart('month')} • ${getPart('hour')}:${getPart(
    'minute'
  )} WIB`;
}
